import useSWR from "swr";
import { adapterSegurosFromApi } from "../adapter/seguros";
import { ENDOSO, POLIZA } from "../data/constants";
import useAuth from "./useAuth";

const poliza = {
    nro: 1,
    nombre: POLIZA,
};
const endoso = {
    nro: 2,
    nombre: ENDOSO,
};

const useSeguros = () => {
    const { user } = useAuth();

    const request = {
        CUIT: user.cuit,
    };

    const { data, error } = useSWR(["/FetchSeguros", request]);

    const seguros = adapterSegurosFromApi(data?.data);

    const ramos = seguros
        .map((seguro) => seguro.ramo)
        .reduce(
            (unique, item) =>
                unique.find((ramo) => ramo.nro === item.nro)
                    ? unique
                    : [...unique, item],
            []
        );

    const hayEndosos = seguros.some((seguro) => seguro.tipo === ENDOSO);

    const tiposSeguro = () => {
        return hayEndosos ? [poliza, endoso] : null;
    };

    return {
        isLoading: !data,
        seguros,
        error,
        ramos,
        tiposSeguro,
    };
};

export default useSeguros;
